module.exports = __webpack_public_path__ + "components/MapControl/svg/Przedszkole_żłobek.svg?c3452100";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Przedszkole_żłobek.svg
// module id = 2047
// module chunks = 0